"use client";

import { Home, X, CheckCircle } from "lucide-react";
import { Button } from "./Button";

export default function BusinessSuccess({ formData, onClose }) {
  // Log all collected data
  console.log("All business form data:", formData);

  return (
    <div className="p-6 flex flex-col items-center text-center">
      <div className="absolute top-4 right-4">
        <button
          onClick={onClose}
          className="text-gray-500 hover:text-gray-700"
          aria-label="Close"
        >
          <X size={20} />
        </button>
      </div>

      <div className="w-24 h-24 mb-6 bg-green-100 rounded-full flex items-center justify-center">
        <CheckCircle size={48} className="text-green-500" />
      </div>

      <h2 className="text-2xl font-bold mb-4">
        Business Registered Successfully!
      </h2>
      <p className="text-gray-600 mb-8">
        Your business "{formData.businessname}" has been submitted for review.
        <br />
        We'll contact you at {formData.contactemail} once approved.
      </p>

      <Button
        onClick={onClose}
        className="flex items-center justify-center bg-[#7B189F] text-white border border-[#7B189F] px-4 py-2 rounded-md font-medium hover:bg-[#5a0f7a] transition-colors"
      >
        <Home size={18} className="mr-2" />
        Back to Home
      </Button>
    </div>
  );
}
